//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            recurring: {},
            starts_at: moment().format("MM/DD/YYYY"),
            ends_at: moment().format("MM/DD/YYYY"),
            amount: 0.00,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            }
        };
    },
    created: function created() {
        Event.$on('edit-gl-wizard-recurring', this.editGLWizardRecurring);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('edit-gl-wizard-recurring');
    },

    methods: {
        editGLWizardRecurring: function editGLWizardRecurring(item) {
            var $el = this;
            $el.item = item;
            $el.$children[0].$data.showSmallModal = true;
            $el.starts_at = moment(item.starts_at).format("MM/DD/YYYY");
            $el.ends_at = item.ends_at ? moment(item.ends_at).format("MM/DD/YYYY") : '';
            $el.amount = item.amount;
        },

        save: function save() {
            var $el = this;
            $el.recurring.id = this.item.id;
            $el.recurring.starts_at = this.starts_at;
            $el.recurring.ends_at = this.ends_at;
            $el.recurring.amount = this.amount;
            axios.post('/prototype/accounting/accounts-receivable/transaction/recurring/update', $el.recurring).then(function (response) {
                if (response.data.error) {
                    $el.$snotify.error("Error updating transaction: " + response.data.error);
                } else {
                    $el.$snotify.success('The transaction was updated');
                    Event.$emit('refresh-ar-recurring-transactions');
                    Event.$emit('refresh-resident-recurring-transactions');
                    Event.$emit('close-small-modal');
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/transactions/ResidentLedgerWizardRecurring.vue
// module id = 8c9W
// module chunks = 0 1